import React from 'react'

import { TtIcon } from '@23/ui-react'

import { useAppSelector } from '../../../../../../redux-types'

const FocusAudienceCount = () => {
  const viewersCount = useAppSelector(
    (state) => state.webinar.webinarInfo.current_viewers
  )

  return (
    <div className="focus-widget focus-audience-count">
      <TtIcon library="one" name="account-multiple" />
      <span>{viewersCount || 0}</span>
    </div>
  )
}
export { FocusAudienceCount }
